import { useSearchParams, useNavigate } from 'react-router-dom';

export function useModal() {
  const [searchParams, setSearchParams] = useSearchParams();
  const navigate = useNavigate();

  const id = searchParams.get('open');

  const open = (newId) => {
    searchParams.set('open', newId);
    setSearchParams(searchParams);
  };

  const close = () => {
    navigate(-1);
  };

  return { id, open, close };
}
